import React, { useState } from "react";
import ReactModal from "react-modal";
import Checkbox from "src/components/Checkbox";
import { FC_FLOW_PRE_URL, FC_FLOW_POS_URL } from "../../../../../services/api";

import {
  CloseButton,
  Container,
  Line,
  Link,
  ModalHeader,
  Terms,
  TextBlock,
  Button,
} from "./styles";

function Footer({
  buttonColor,
  terms,
  modalOpen,
  disabled,
  cupons,
  textColor,
}) {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Container blur={modalOpen}>
        <Terms>
          <Checkbox
            id="check-term"
            disabled={modalOpen}
            onChange={() => setChecked(!checked)}
            className="termoAceite"
          />
          <p>
            Estou ciente que, ao prosseguir, aceito os{" "}
            <b
              onClick={() => !disabled && setOpenModal(true)}
              disabled={modalOpen}
              style={{
                pointerEvents: disabled && "none",
              }}
            >
              termos e condições
            </b>{" "}
            da campanha.
          </p>
        </Terms>
        <div className="botoesCupons">
          <Link
            disabled={!checked}
            href={
              disabled ? "" : `${FC_FLOW_PRE_URL}?origem=lp&codigo=${cupons[0]}`
            }
          >
            <Button disabled={!checked} color={textColor}>
              Quero pré-pago
            </Button>
          </Link>
          <Link
            disabled={!checked}
            href={
              disabled ? "" : `${FC_FLOW_POS_URL}?origem=lp&codigo=${cupons[1]}`
            }
          >
            <Button disabled={!checked} color={textColor}>
              Quero pós-pago
            </Button>
          </Link>
        </div>
      </Container>
      <ReactModal isOpen={openModal} onRequestClose={() => setOpenModal(false)}>
        <ModalHeader>
          <CloseButton
            src="/gwmbrasil/assets/icon-close.png"
            onClick={() => setOpenModal(false)}
          />
        </ModalHeader>
        <div>
          {terms.content &&
            terms.content?.map((term) => (
              <Line>
                {term.content.map(({ value, marks }) => {
                  const className = !!marks
                    ? marks.map((mark) => mark.type).join(" ")
                    : "";
                  return <TextBlock className={className}>{value}</TextBlock>;
                })}
              </Line>
            ))}
        </div>
      </ReactModal>
    </>
  );
}

export default Footer;
